import { render, staticRenderFns } from "./Personage.vue?vue&type=template&id=a8089dd2&scoped=true&"
import script from "./Personage.vue?vue&type=script&lang=js&"
export * from "./Personage.vue?vue&type=script&lang=js&"
import style0 from "./Personage.vue?vue&type=style&index=0&id=a8089dd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8089dd2",
  null
  
)

export default component.exports